import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Layout from '../views/layout/layout';

import LoginView from '../views/login/loginview';
import PurchaseOrder from '../views/purchaseOrder';
import AddPurchaseOrder from '../components/purchaseOrder/addPurchaseOrder';
import EditPurchaseOrder from '../components/purchaseOrder/editPurchaseOrder';
import Bill from '../views/bill';
import AddBill from '../components/bill/addBill';
import EditBill from '../components/bill/editBill';
import ViewBill from '../components/bill/viewBill';
import Payment from '../views/payment';
import AddPayment from '../components/payment/addPayment';
import EditPayment from '../components/payment/editPayment';
import ViewPayment from '../components/payment/viewPayment';
import Product from '../views/masters/product';
import AddProduct from '../components/mastersComponents/product/addProduct';
import EditProduct from '../components/mastersComponents/product/editProduct';
import Expense from '../views/masters/expense';
import Branch from '../views/masters/branch';
import Vendor from '../views/masters/vendor';
import AddVendor from '../components/mastersComponents/vendor/addVendor';
import EditVendor from '../components/mastersComponents/vendor/editVendor';
import Home from '../components/Home/home';
import DebitNote from '../views/debitNote';
import AwsReports from '../views/awsReports/awsReports';

class Routes extends Component {
    render(){
        return (
            <React.Fragment>
                <Layout>
                    <Switch>
                        {localStorage.getItem('role')=== "User" ?
                        <>
                            <Route path="/" exact render={() => (localStorage.getItem("apiToken") ? (<Redirect to='/' />) : (<LoginView />))} />
                            <Route path="/" exact render={() => (localStorage.getItem("apiToken") ? (<Redirect to='/' />) : (<LoginView />))} />
                        </>
                        :
                        <>
                            <Route path="/" exact render={() => (localStorage.getItem("apiToken") ? (<Redirect to='/' />) : (<LoginView />))} />
                            <Route path='/home' exact component={localStorage.getItem("apiToken") ? Home : LoginView} />

                            <Route path="/purchaseorder" exact component={localStorage.getItem("apiToken") ? PurchaseOrder : LoginView} />
                            <Route path="/add-purchaseorder" exact component={localStorage.getItem("apiToken") ? AddPurchaseOrder : LoginView} />
                            <Route path="/edit-purchaseorder" exact component={localStorage.getItem("apiToken") ? EditPurchaseOrder : LoginView} />

                            <Route path="/bill" exact component={localStorage.getItem("apiToken") ? Bill : LoginView} />
                            <Route path="/add-bill" exact component={localStorage.getItem("apiToken") ? AddBill : LoginView} />
                            <Route path="/edit-bill" exact component={localStorage.getItem("apiToken") ? EditBill : LoginView} />
                            <Route path="/view-bill" exact component={localStorage.getItem("apiToken") ? ViewBill : LoginView} />

                            <Route path="/debit-note" exact component={localStorage.getItem("apiToken") ? DebitNote : LoginView} />

                            <Route path="/payment" exact component={localStorage.getItem("apiToken") ? Payment : LoginView} />
                            <Route path="/add-payment" exact component={localStorage.getItem("apiToken") ? AddPayment : LoginView} />
                            <Route path="/edit-payment" exact component={localStorage.getItem("apiToken") ? EditPayment : LoginView} />
                            <Route path="/view-payment" exact component={localStorage.getItem("apiToken") ? ViewPayment : LoginView} />

                            <Route path="/expense" exact component={localStorage.getItem("apiToken") ? Expense : LoginView} />

                            <Route path="/partner" exact component={localStorage.getItem("apiToken") ? Vendor : LoginView} />
                            <Route path="/add-partner" exact component={localStorage.getItem("apiToken") ? AddVendor : LoginView} />
                            <Route path="/edit-partner" exact component={localStorage.getItem("apiToken") ? EditVendor : LoginView} />

                            <Route path="/branch" exact component={localStorage.getItem("apiToken") ? Branch : LoginView} />
                            <Route path="/product" exact component={localStorage.getItem("apiToken") ? Product : LoginView} />
                            <Route path="/add-product" exact component={localStorage.getItem("apiToken") ? AddProduct : LoginView} />
                            <Route path="/edit-product" exact component={localStorage.getItem("apiToken") ? EditProduct : LoginView} /> 

                            <Route path="/reportsheet" exact component={localStorage.getItem("apiToken") ? AwsReports : LoginView} />  

                        </>
                        }
                    </Switch>
                </Layout>
            </React.Fragment>
        )
    }
}

export default Routes